export const calendarDay = value => {
  if (!value) return NaN;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return NaN;
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: "America/Argentina/Buenos_Aires", year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(date);
  const part = type => Number(parts.find(p => p.type === type).value);
  return Date.UTC(part("year"), part("month") - 1, part("day")) / 86400000;
};
